import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { Spinner } from 'react-bootstrap'

import Title from '../components/ui/Title/Title'
import Paragraphs from '../components/ui/Paragraphs/Paragraphs'
import TabButton from '../components/ui/TabButton/TabButton'
import NavigationCards from '../components/NavigationCards/NavigationCards'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import useFetch from '../hooks/useFetch'
import useIsMobile from '../hooks/useIsMobile'
import { getImageUrl, isArabic } from '../utils'
import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'

import styles from './pages.module.scss'

function Infrastructure() {
  const { pathname, state } = useLocation()
  const path = pathname.split('/')
  const { language } = useLanguage()
  const isArabiclang = isArabic(language?.code)

  const paramList = {
    upi: 'infrastructure-upi',
    rupay: 'infrastructure-rupay',
  }

  const currentSectionPath = path[path.length - 1]
  const [url, setUrl] = useState(paramList[currentSectionPath])
  const { data, loading, error } = useFetch(
    url,
    (resp) => resp.data,
    undefined,
    state?.count
  )

  useEffect(() => {
    const fetchData = async () => {
      if (paramList[currentSectionPath] !== url) {
        const key = await paramList[currentSectionPath]
        setUrl(key)
      }
    }
    fetchData()
  }, [path])

  const isMobile = useIsMobile()

  useEffect(() => {
    const html = document.documentElement
    // Apply styles to the <html> element
    html.style.msOverflowStyle = 'none' // For IE and Edge
    html.style.scrollbarWidth = 'none' // For Firefox

    // Additional styles to hide scrollbar for other browsers

    // Cleanup function to reset styles when the component unmounts
    return () => {
      html.style.msOverflowStyle = ''
      html.style.scrollbarWidth = ''
    }
  }, [])

  const tabs = data?.tabs
  const breadcrumbs = data?.breadcrumbs
  const navigations = data?.pagenavigations
  const pageTitle = data?.pagetitle
  const paragraphs = data?.paragraphs
  const buttonText = data?.buttontext
  const backgroundImage = data?.backgroundImage

  const handleNavClick = (tabPath) => {
    if (pathname === tabPath) {
      window.scrollTo(0, 0)
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage:
              !isMobile && `url(${getImageUrl(backgroundImage)})`,
            backgroundPositionY: isArabiclang ? '-3.5rem' : '0rem',
          }}
        >
          <div className={classNames('', styles.interoperability)}>
            <div className={styles.pageContent}>
              <div
                className={classNames('page-container', styles.topContainer)}
              >
                <div className={styles.descriptionContainer}>
                  <Title
                    classname={classNames(
                      styles.pageTitle,
                      'page-title-padding'
                    )}
                  >
                    {pageTitle}
                  </Title>
                  <Paragraphs
                    paragraphs={paragraphs}
                    className={classNames('opacity-70', styles.headingPara)}
                  />
                </div>
                <div
                  className={classNames('tabs-container', styles.tabContainer)}
                >
                  {tabs?.map((tab, index) => {
                    return (
                      <TabButton
                        key={index}
                        label={tab?.link?.label}
                        path={tab?.link?.path}
                        type="link"
                        handleNavClick={() => {
                          handleNavClick(tab?.link?.path)
                        }}
                        buttonClassname={styles.infrastructureBuildTabWidth}
                      />
                    )
                  })}
                </div>
              </div>
              <Outlet
                context={{
                  sectiondata: { ...data?.sectiondata, buttonText: buttonText },
                  page: path[2],
                }}
              />
            </div>
            <NavigationCards
              navigations={navigations}
              className={'page-container'}
            />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      )}
    </>
  )
}

export default Infrastructure
